import { trigger, transition, query, style, sequence, animate, state } from '@angular/animations';

export const chatPanelAnimation = trigger('chatAnimation', [
  state('minimized', style({ height: '40px', width: '250px' })),
  transition('void => expanded', [
    style({ height: '0' }),
    query('.app-chat-viewer', style({ overflow: 'hidden' })),
    sequence([
      animate('500ms ease-out', style({ height: '*' }))
    ])
  ]),
  transition('void => minimized', [
    style({ height: '0' }),
    sequence([
      animate('500ms ease-out', style({ height: '40px' }))
    ])
  ]),
  transition('minimized => expanded', [
    style({ height: '40px', width: '250px' }),
    query('.app-chat-viewer', style({ overflow: 'hidden' })),
    sequence([
      animate('500ms ease-out', style({ width: '*' })),
      animate('500ms ease-out', style({ height: '*' })),
      query('.app-chat-viewer', style({ overflow: '*' }))
    ])
  ]),
  transition('expanded => minimized', [
    style({ height: '*', width: '350px' }),
    sequence([
      animate('500ms ease-out', style({ height: '40px' })),
      animate('500ms ease-out', style({ width: '250px' }))
    ])
  ])
]);
